import * as React from 'react'

const SvgDashBoardShareIcon = ({ stroke = 'white' }) => (
  <svg
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke={stroke}
  >
    <path
      d="M5.9016 10.1189C6.07017 9.7824 6.16504 9.40258 6.16504 9.00061C6.16504 8.59864 6.07017 8.21882 5.9016 7.88233M5.9016 10.1189C5.49115 10.9382 4.64378 11.5006 3.66504 11.5006C2.28433 11.5006 1.16504 10.3813 1.16504 9.00061C1.16504 7.6199 2.28433 6.50061 3.66504 6.50061C4.64378 6.50061 5.49115 7.06304 5.9016 7.88233M5.9016 10.1189L11.4285 12.8823M5.9016 7.88233L11.4285 5.11889M11.4285 5.11889C11.8389 5.93818 12.6863 6.50061 13.665 6.50061C15.0458 6.50061 16.165 5.38132 16.165 4.00061C16.165 2.6199 15.0458 1.50061 13.665 1.50061C12.2843 1.50061 11.165 2.6199 11.165 4.00061C11.165 4.40258 11.2599 4.7824 11.4285 5.11889ZM11.4285 12.8823C11.2599 13.2188 11.165 13.5986 11.165 14.0006C11.165 15.3813 12.2843 16.5006 13.665 16.5006C15.0458 16.5006 16.165 15.3813 16.165 14.0006C16.165 12.6199 15.0458 11.5006 13.665 11.5006C12.6863 11.5006 11.8389 12.063 11.4285 12.8823Z"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgDashBoardShareIcon
